import { render, staticRenderFns } from "./payment-details.vue?vue&type=template&id=5115c861"
import script from "./payment-details.vue?vue&type=script&lang=js"
export * from "./payment-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports